import { useTranslation } from 'react-i18next';
import { getClaimStatusLabel } from '@/utils/claimHelpers';
import { ClaimStatusSlug } from '@/types';

interface ClaimStatusTagProps {
  slug: ClaimStatusSlug;
}

const STATUS_COLORS: Record<string, { bg: string; text: string }> = {
  pending:              { bg: 'rgba(245,158,11,0.12)',  text: 'rgb(180,83,9)' },
  'under-review':      { bg: 'rgba(59,130,246,0.12)',  text: 'rgb(37,99,235)' },
  approved:            { bg: 'rgba(6,182,212,0.12)',    text: 'rgb(14,116,144)' },
  rejected:            { bg: 'rgba(239,68,68,0.12)',    text: 'rgb(220,38,38)' },
  compensated:         { bg: 'rgba(34,197,94,0.12)',    text: 'rgb(22,163,74)' },
  'compensation-failed': { bg: 'rgba(239,68,68,0.12)', text: 'rgb(220,38,38)' },
  closed:              { bg: 'rgba(107,114,128,0.12)',  text: 'rgb(75,85,99)' },
};

const ClaimStatusTag = ({ slug }: ClaimStatusTagProps) => {
  const { t } = useTranslation();
  const label = getClaimStatusLabel(slug, t);
  const colors = STATUS_COLORS[slug] ?? { bg: 'rgba(107,114,128,0.12)', text: 'rgb(75,85,99)' };

  return (
    <span
      style={{
        display: 'inline-flex',
        alignItems: 'center',
        fontSize: 11,
        fontWeight: 600,
        color: colors.text,
        backgroundColor: colors.bg,
        padding: '4px 10px',
        borderRadius: 9999,
        lineHeight: '16.5px',
        whiteSpace: 'nowrap',
      }}
    >
      {label}
    </span>
  );
};

export default ClaimStatusTag;
